(()=>{
  'use strict';

  const syncGroup=(root,select)=>{
    if(!select)return;
    root.querySelectorAll(`[data-crbn-v2-choice][data-target="${CSS.escape(select.id)}"]`).forEach(button=>{
      const selected=button.dataset.value===select.value;
      button.classList.toggle('is-selected',selected);
      button.setAttribute('aria-pressed',String(selected));
    });
  };

  const setSelectValue=(root,button)=>{
    const id=button.dataset.target||'';
    const select=id?root.querySelector(`#${CSS.escape(id)}`):null;
    if(!select||button.getAttribute('aria-disabled')==='true'||button.disabled)return;
    if(![...select.options].some(option=>option.value===button.dataset.value))return;
    select.value=button.dataset.value;
    syncGroup(root,select);
    select.dispatchEvent(new Event('change',{bubbles:true}));
  };

  const toggleConditional=(root,group,select,visible,resetValue)=>{
    if(!group||!select)return;
    group.hidden=!visible;
    select.disabled=!visible;
    if(!visible&&resetValue!==undefined&&select.value!==resetValue){
      select.value=resetValue;
      syncGroup(root,select);
      select.dispatchEvent(new Event('change',{bubbles:true}));
    }
  };

  document.querySelectorAll('[data-crbn-configurator]').forEach(root=>{
    if(!root.querySelector('.crbn-v2-group'))return;
    if(root.dataset.crbnV2Ready==='true')return;
    root.dataset.crbnV2Ready='true';

    const reducedMotion=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches===true;
    const productSection=root.closest('.crbn-product');
    const assistance=productSection?.querySelector('.crbn-v2-assistance')||root.querySelector('.crbn-v2-assistance');
    if(assistance){
      let assistanceFrame=0;
      const syncAssistance=()=>{
        assistanceFrame=0;
        const visible=window.scrollY>=500;
        assistance.classList.toggle('is-v2-assistance-visible',visible);
      };
      const queueAssistance=()=>{
        if(assistanceFrame)return;
        assistanceFrame=requestAnimationFrame(syncAssistance);
      };
      window.addEventListener('scroll',queueAssistance,{passive:true});
      syncAssistance();
    }
    const heroMedia=productSection?.querySelector('[data-crbn-v2-hero-media]')||null;
    const heroCopy=[...(productSection?.querySelectorAll('[data-crbn-v2-hero-copy]')||[])];
    const optionItemSelector='.crbn-v2-card,.crbn-v2-swatch,.crbn-v2-custom-color-choice,.crbn-v2-color-picker-control';
    const prepareChildStagger=(container,selector=optionItemSelector)=>{
      if(!container)return[];
      const items=[...container.querySelectorAll(selector)].filter(item=>!item.hidden);
      if(reducedMotion)return items;
      items.forEach(item=>{
        item.classList.remove('is-v2-child-visible');
        item.classList.add('crbn-v2-stagger-child');
      });
      return items;
    };
    const revealChildStagger=(container,selector=optionItemSelector,baseDelay=0,step=60)=>{
      const items=prepareChildStagger(container,selector);
      if(reducedMotion)return;
      items.forEach((item,index)=>{
        const delay=baseDelay+Math.min(index*step,360);
        item.style.setProperty('--crbn-v2-child-delay',`${delay}ms`);
        item.classList.add('is-v2-child-visible');
        item.addEventListener('animationend',()=>{
          item.classList.remove('crbn-v2-stagger-child','is-v2-child-visible');
          item.style.removeProperty('--crbn-v2-child-delay');
        },{once:true});
      });
    };
    heroMedia&&prepareChildStagger(heroMedia,'.crbn-product__thumb');
    root.querySelectorAll('.crbn-v2-group').forEach(group=>prepareChildStagger(group));
    let heroStarted=false;
    let beginInitialReveals=()=>{};
    const startHero=()=>{
      if(heroStarted)return;
      heroStarted=true;
      if(reducedMotion){
        beginInitialReveals();
        return;
      }
      heroMedia?.classList.add('crbn-v2-hero-enter');
      heroMedia?.style.setProperty('--crbn-v2-hero-delay','0ms');
      heroCopy.forEach((element,index)=>{
        element.classList.add('crbn-v2-hero-enter');
        element.style.setProperty('--crbn-v2-hero-delay',`${190+(index*80)}ms`);
      });
      window.setTimeout(()=>{
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
          heroMedia?.classList.add('is-v2-hero-visible');
          heroCopy.forEach(element=>element.classList.add('is-v2-hero-visible'));
          window.setTimeout(()=>revealChildStagger(heroMedia,'.crbn-product__thumb',0,55),180);
          window.setTimeout(beginInitialReveals,520);
        }));
      },110);
    };

    const revealObserver=!reducedMotion&&'IntersectionObserver' in window?new IntersectionObserver(entries=>{
      entries.filter(entry=>entry.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top).forEach((entry,index)=>{
        const groupDelay=Math.min(index*70,210);
        entry.target.style.setProperty('--crbn-v2-reveal-delay',`${groupDelay}ms`);
        entry.target.classList.add('is-v2-visible');
        if(entry.target.classList.contains('crbn-v2-group'))revealChildStagger(entry.target,optionItemSelector,groupDelay+160,65);
        revealObserver.unobserve(entry.target);
      });
    },{threshold:.04,rootMargin:'0px 0px -5% 0px'}):null;

    const revealOnScroll=element=>{
      if(!element||element.hidden)return;
      element.classList.add('crbn-v2-motion-reveal');
      if(reducedMotion||!revealObserver){
        element.classList.add('is-v2-visible');
        return;
      }
      revealObserver.observe(element);
    };

    beginInitialReveals=()=>{
      root.querySelectorAll('.crbn-v2-motion-reveal:not([hidden])').forEach(revealOnScroll);
    };

    if(reducedMotion){
      startHero();
    }else{
      const mainImage=productSection?.querySelector('[data-crbn-main-image]');
      if(!mainImage||mainImage.complete){
        startHero();
      }else{
        mainImage.addEventListener('load',startHero,{once:true});
        mainImage.addEventListener('error',startHero,{once:true});
        window.setTimeout(startHero,1400);
      }
    }

    const revealConditional=element=>{
      if(!element||element.hidden)return;
      if(reducedMotion){
        element.classList.add('is-v2-visible');
        return;
      }
      const rect=element.getBoundingClientRect();
      const inViewport=rect.bottom>0&&rect.top<window.innerHeight*.96;
      if(element.classList.contains('crbn-v2-group')&&!inViewport){
        element.classList.remove('is-v2-visible');
        prepareChildStagger(element);
        revealOnScroll(element);
        return;
      }
      if(element.classList.contains('crbn-v2-group')){
        element.style.removeProperty('--crbn-v2-reveal-delay');
        element.classList.add('is-v2-visible');
        revealChildStagger(element,optionItemSelector,120,65);
      }
      element.classList.remove('crbn-v2-condition-enter');
      void element.offsetWidth;
      element.classList.add('crbn-v2-condition-enter');
      element.addEventListener('animationend',()=>element.classList.remove('crbn-v2-condition-enter'),{once:true});
    };

    const material=root.querySelector('#crbn-v2-material');
    const flake=root.querySelector('#crbn-v2-flake');
    const flakeGroup=root.querySelector('[data-crbn-v2-flake-group]');
    const stripeStyle=root.querySelector('#crbn-v2-stripe-style');
    const stripeColors=root.querySelector('[data-crbn-v2-stripe-colors]');
    const shape=root.querySelector('#crbn-v2-shape');
    const led=root.querySelector('#crbn-v2-led');
    const ledYes=root.querySelector('[data-crbn-v2-choice][data-target="crbn-v2-led"][data-value="Yes"]');
    const ledNote=root.querySelector('[data-crbn-v2-led-note]');
    const heatedOriginal=root.querySelector('#crbn-v2-heated-original');
    const heatRetention=root.querySelector('#crbn-v2-heat-retention');
    const heatRetentionGroup=root.querySelector('[data-crbn-v2-heat-retention-group]');
    const factoryPaddles=root.querySelector('#crbn-v2-factory-paddles');
    const paddleUpgrade=root.querySelector('#crbn-v2-paddle-upgrade');
    const paddleUpgradeGroup=root.querySelector('[data-crbn-v2-paddle-upgrade-group]');
    const customColorPicker=root.querySelector('[data-crbn-grip-color-picker]');
    const customColorPreview=root.querySelector('[data-crbn-v2-color-preview]');
    const customColorHex=root.querySelector('[data-crbn-v2-color-hex]');
    const stitchColorPicker=root.querySelector('[data-crbn-stitch-color-picker]');
    const stitchColorPreview=root.querySelector('[data-crbn-v2-stitch-color-preview]');
    const stitchColorHex=root.querySelector('[data-crbn-v2-stitch-color-hex]');
    const stitchMatch=root.querySelector('#crbn-v2-stitch-match');
    const stitchMatchStripe=root.querySelector('[data-crbn-stitch-match-stripe]');

    const syncCustomColor=()=>{
      if(!customColorPicker)return;
      const value=(customColorPicker.value||'#000000').toUpperCase();
      if(customColorPreview)customColorPreview.style.setProperty('--picker-color',value);
      if(customColorHex)customColorHex.textContent=value;
    };
    customColorPicker?.addEventListener('input',syncCustomColor);
    customColorPicker?.addEventListener('change',syncCustomColor);
    syncCustomColor();

    const syncStitchColor=()=>{
      if(!stitchColorPicker)return;
      const value=(stitchColorPicker.value||'#000000').toUpperCase();
      if(stitchColorPreview)stitchColorPreview.style.setProperty('--picker-color',value);
      if(stitchColorHex)stitchColorHex.textContent=value;
    };
    stitchColorPicker?.addEventListener('input',syncStitchColor);
    stitchColorPicker?.addEventListener('change',syncStitchColor);
    syncStitchColor();

    const refresh=()=>{
      toggleConditional(root,flakeGroup,flake,material?.value==='Forged carbon','No Flakes');

      if(stripeColors){
        const visible=stripeStyle?.value==='Single-Tone Stripe';
        stripeColors.hidden=!visible;
        const stripeSelect=stripeColors.querySelector('select');
        if(stripeSelect)stripeSelect.disabled=!visible;
      }

      if(stitchMatch&&stitchMatchStripe){
        const stripeUnavailable=stripeStyle?.value!=='Single-Tone Stripe';
        stitchMatchStripe.classList.toggle('is-disabled',stripeUnavailable);
        stitchMatchStripe.setAttribute('aria-disabled',String(stripeUnavailable));
        if(stripeUnavailable&&stitchMatch.value==='Top stripe color'){
          stitchMatch.value='Grip color';
          syncGroup(root,stitchMatch);
          stitchMatch.dispatchEvent(new Event('change',{bubbles:true}));
        }
      }

      toggleConditional(root,heatRetentionGroup,heatRetention,heatedOriginal?.value==='Yes','No');
      toggleConditional(root,paddleUpgradeGroup,paddleUpgrade,factoryPaddles?.value==='Yes','None');

      if(shape&&led&&ledYes){
        const incompatible=shape.value==='Flat Top & Flat Bottom';
        ledYes.classList.toggle('is-disabled',incompatible);
        ledYes.setAttribute('aria-disabled',String(incompatible));
        if(incompatible&&led.value==='Yes'){
          led.value='No';
          syncGroup(root,led);
          led.dispatchEvent(new Event('change',{bubbles:true}));
        }
        if(ledNote)ledNote.classList.toggle('is-active',incompatible);
      }

      root.querySelectorAll('select[id^="crbn-v2-"]').forEach(select=>syncGroup(root,select));
    };

    root.addEventListener('click',event=>{
      const button=event.target.closest('[data-crbn-v2-choice]');
      if(!button||!root.contains(button))return;
      event.preventDefault();
      setSelectValue(root,button);
      refresh();
    });

    root.querySelectorAll('select[id^="crbn-v2-"]').forEach(select=>select.addEventListener('change',refresh));
    refresh();

    const conditionalObserver=new MutationObserver(mutations=>{
      mutations.forEach(mutation=>{
        const element=mutation.target;
        if(!(element instanceof HTMLElement)||!element.matches('.crbn-v2-group,.crbn-v2-conditional,.crbn-field'))return;
        if(element.hidden){
          revealObserver?.unobserve(element);
          element.classList.remove('is-v2-visible','crbn-v2-condition-enter');
          if(element.classList.contains('crbn-v2-group'))prepareChildStagger(element);
          return;
        }
        revealConditional(element);
      });
    });
    conditionalObserver.observe(root,{subtree:true,attributes:true,attributeFilter:['hidden']});
  });
})();
